import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { Alert, Keyboard, StyleSheet, ScrollView } from 'react-native';
import useColors from 'hooks/useColors';
import StatusBar from 'design-system/StatusBar';
import { AppView, CardView, SettingsItemInput, rem } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { KeyboardAvoidingButton } from 'design-system/KeyboardAvoidingButton';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import IconSpace from 'design-system/icons/IconSpace';
import { useAutoFocusInput } from 'hooks/useAutoFocusInput';
import SpaceNameSuggestions from './components/SpaceNameSuggestions';
import { isWeb } from '../../constants';
const CreateSpaceName = ({ navigation, }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: '',
            title: 'Name your space',
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const [text, setText] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = useCallback(() => {
        setIsFocused(true);
    }, []);
    const handleBlur = useCallback(() => {
        setIsFocused(false);
    }, []);
    const confirm = useCallback(() => {
        const name = text;
        if (name.length < 3) {
            Alert.alert('Sorry, can’t use that 😭', 'Enter 3 symbols minimum.', [
                { text: 'Ok, thanks' },
            ]);
        }
        else {
            navigation.navigateDeprecated('CreateSpaceAccounts', {
                spaceInfo: {
                    space: {
                        id: -1,
                        name,
                        type: 'PERSONAL',
                        accessCode: '',
                        accessLink: '',
                        createdBy: -1,
                        createdAt: '',
                        isDefault: false,
                    },
                },
            });
        }
    }, [text]);
    const [suggestedData, setSuggestedData] = useState(undefined);
    const handleSuggestionPress = useCallback((text) => {
        Keyboard.dismiss();
        setText(text);
        setSuggestedData({
            name: text,
        });
    }, []);
    const nameInputRef = useRef(null);
    useAutoFocusInput(nameInputRef);
    const nameInput = (<SettingsItemInput style={styles.nameInput} ref={nameInputRef} description="Name" icon={<IconSpace gradientKey="ultimate"/>} value={text} onChangeText={setText} placeholder="Name your space..." iconSize={44} returnKeyType="done" onFocus={handleFocus} onBlur={handleBlur}/>);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    return (<AppView avoidHeader withFrame={false}>
      <StatusBar barStyle="dark-content" animated/>
      <ScrollView scrollEventThrottle={16} contentContainerStyle={paddingBottom} keyboardShouldPersistTaps="handled">
        <ScreenInfoHeader title="Name your space"/>
        <CardView selectable={isWeb} isSelected={isFocused} noMarginBottom noMarginTop>
          {nameInput}
        </CardView>
        <SpaceNameSuggestions name={text} handleSuggestionPress={handleSuggestionPress} suggestedData={suggestedData}/>
      </ScrollView>
      <KeyboardAvoidingButton brand title="Continue" onPress={confirm} disabled={text.length < 3}/>
    </AppView>);
};
const styles = StyleSheet.create({
    nameInput: {
        marginHorizontal: rem(16),
    },
});
export default CreateSpaceName;
